/**
 * Chatbot FAQ API client (BFF: `/api/v1/store/settings/chatbot/faq[/{intentCode}]`).
 */
import { apiClient } from '@/shared/api';
import type { ChatbotFaqIntent, ChatbotFaqIntentList, UpsertChatbotFaqIntentRequest } from '../model/types';

const BASE = '/api/v1/store/settings/chatbot/faq';

export const listChatbotFaqIntents = async (locale: string): Promise<ChatbotFaqIntentList> =>
  (await apiClient.get<ChatbotFaqIntentList>(BASE, { params: { locale } })).data;

export const getChatbotFaqIntent = async (intentCode: string, locale: string): Promise<ChatbotFaqIntent> =>
  (
    await apiClient.get<ChatbotFaqIntent>(`${BASE}/${encodeURIComponent(intentCode)}`, {
      params: { locale },
    })
  ).data;

export const putChatbotFaqIntent = async (
  intentCode: string,
  body: UpsertChatbotFaqIntentRequest,
): Promise<ChatbotFaqIntent> =>
  (await apiClient.put<ChatbotFaqIntent>(`${BASE}/${encodeURIComponent(intentCode)}`, body)).data;

export const deleteChatbotFaqIntent = async (intentCode: string, locale: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${encodeURIComponent(intentCode)}`, { params: { locale } });
};
